

<div class="page-title-area upper-margin">
    <div class="container">
        <div class="page-title-content">
            <br />
            <br />
            <h2>{{'Contact_Us' | translate }}</h2>
            <!--<a routerLink="/">{{'Home' | translate }}</a>-->

        </div>
    </div>
</div>
<!-- data-aos="zoom-in-up"-->
<div id="map" class="container my-4 d-flex justify-content-center">
    <div class="map-container border rounded shadow">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d17385.756641658467!2d58.116125160311526!3d23.643569087124014!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e8de314d63d3a5f%3A0x508a8a2e2d06e748!2z2YXZg9iq2KjYqSDYo9mF2KzYp9ivIEFtZ2FkIGJvb2tzaG9w!5e0!3m2!1sen!2som!4v1704760019589!5m2!1sen!2som"
                frameborder="0"
                style="border:0"
                allowfullscreen=""
                loading="lazy">
        </iframe>
    </div>
</div>
<!-- data-aos="fade-up"
         data-aos-duration="100"-->
<section class="contact-area m-3 p-3">
    <div class="container">
        <div class="row">
            <div class="col-lg-5 col-md-12">
                <div class="contact-info">
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <h3>{{'Address' | translate }}</h3>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <p>{{'Footer_Address' | translate }}</p>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <ul class="contact-list">
                        <li><i class='bx bx-phone-call'></i><a href="tel:+96897676711" dir="ltr">+968 97676711</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:AMGADINTERNATIONALB@GMAIL.COM">AMGADINTERNATIONALB@GMAIL.COM</a></li>
                    </ul>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <h3>{{'Opening_Hours' | translate }}:</h3>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <p>{{'Footer_Working_Hours' | translate }}</p>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <p>{{'Footer_Working_HoursFri' | translate }}</p>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <h3>{{'Follow_Us' | translate }}:</h3>
                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                    <ul class="social">
                        <li><a href="https://www.tiktok.com/@amgadbookshop" target="_blank"><i class='bx bxl-tiktok'></i></a></li>
                        <li><a href="https://www.instagram.com/amgadbookshop/" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <li><a href="https://www.youtube.com/@amgadbookshop8783/" target="_blank"><i class='bx bxl-youtube'></i></a></li>
                        <li><a href="https://twitter.com/amgadbookshop" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="https://www.facebook.com/profile.php?id=100069768820670" target="_blank"><i class='bx bxl-facebook'></i></a></li>

                    </ul>
                </div>
            </div>

            <!-- data-aos="fade-up" data-aos-delay="300"-->
            <div class="col-lg-7 col-md-12">
                <div class="contact-form">
                    <h3>{{'Drop_Us_A_Line' | translate }}</h3>
                    <!--   StartForm -->
                    <form #contactForm="ngForm" (ngSubmit)="submit(contactForm.value)">
                        <div class="row">
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group mb-3">
                                    <div class="select-box">
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <label>{{'Name' | translate }} <span>*</span></label>
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <input required minlength="3" maxlength="50" ngModel name="name" type="text" #name="ngModel" class="form-control" id="name" placeholder="{{'Name' | translate }}">
                                    </div>
                                    <div class="alert alert-danger" *ngIf="name.touched && !name.valid">
                                        <div *ngIf="name.errors.required">{{'Name_is_required' | translate }}</div>
                                        <div *ngIf="name.errors.minlength">{{'Name_is_minimum' | translate }}{{ name.errors.minlength.requiredLength }} character.</div>
                                        <div *ngIf="name.errors.maxlength">{{'Name_is_maximum_50_character' | translate }}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-6">
                                <div class="form-group mb-3">
                                    <div class="select-box">
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <label>{{'Email' | translate }} <span>*</span></label>
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <input required ngModel name="email" type="text" #email="ngModel" class="form-control" id="email" placeholder="{{'Email' | translate }}">
                                    </div>
                                    <div class="alert alert-danger" *ngIf="email.touched && !email.valid">{{'Email_Address_is_required' | translate }}</div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <div class="select-box">
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <label>{{'Phone_Number' | translate }} <span>*</span></label>
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <input required ngModel name="number" type="text" #number="ngModel" class="form-control" id="number" placeholder="{{'PhoneNo' | translate }}">
                                    </div>
                                    <div class="alert alert-danger" *ngIf="number.touched && !number.valid">{{'Phone_number_is_required' | translate }}</div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <!-- data-aos="fade-up" data-aos-delay="100"-->
                                    <label>{{'Enquiry_Type' | translate }} <span>*</span></label>
                                    <!--data-aos="fade-up" data-aos-delay="100"-->
                                    <div class="select-box">
                                        <select required #gnCategoryID="ngModel" name="gnCategoryID" ngModel class="form-control form-select" style="padding-top:5px">


                                            <option *ngFor="let options of categoryData" [value]="options.gnCategoryID">
                                                <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_contentAr  ; else other_contentEn">
                                                </ng-template>
                                                <ng-template #other_contentAr>{{ options.nameAr }}</ng-template>
                                                <ng-template #other_contentEn>{{ options.name }}</ng-template>
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>





                            <div class="col-lg-12 col-md-12">
                                <div class="form-group mb-3">
                                    <div class="select-box">
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <label>{{'Your_Message' | translate }} <span>*</span></label>
                                        <!-- data-aos="fade-up" data-aos-delay="100"-->
                                        <textarea ngModel #message="ngModel" name="message" id="message" cols="30" rows="6" class="form-control" placeholder="{{'Message' | translate }}"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12">
                                <!-- data-aos="fade-up" data-aos-delay="100"-->
                                <button type="submit" class="default-btn" [class.disabled]="!contactForm.valid">{{'Send_Message' | translate }}</button>
                            </div>
                        </div>
                    </form>




                    <!--  </form> -->
                </div>
            </div>
        </div>
    </div>
</section>




